import React from 'react';
import { Link } from 'react-router-dom';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-6 max-w-4xl">
        {/* Header */}
        <div className="mb-8">
          <Link to="/" className="text-blue-600 hover:text-blue-700 font-medium inline-flex items-center mb-4">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
            </svg>
            Volver al Inicio
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Política de Privacidad</h1>
          <p className="text-gray-600">Última actualización: 6 de agosto de 2025</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm p-8">
          <div className="prose max-w-none">
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introducción</h2>
              <p className="text-gray-700 mb-4">
                K Labs Sa de CV ("nosotros", "nuestro", "la Empresa") respeta su privacidad y se compromete a proteger la información personal que pueda recopilar a través de la aplicación móvil "Facturas Simples" (en adelante, "la Aplicación").
              </p>
              <p className="text-gray-700 mb-4">
                Esta Política de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos su información cuando utiliza nuestra Aplicación.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Información que Recopilamos</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">2.1 Información que Usted Proporciona</h3>
              <p className="text-gray-700 mb-4">
                Cuando utiliza la Aplicación, puede proporcionarnos voluntariamente la siguiente información:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Información de la empresa (nombre, dirección, RFC, régimen fiscal)</li>
                <li>Información de contacto (email, teléfono)</li>
                <li>Datos de facturación y clientes</li>
                <li>Productos y servicios que ofrece</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">2.2 Información Recopilada Automáticamente</h3>
              <p className="text-gray-700 mb-4">
                La Aplicación puede recopilar automáticamente cierta información técnica:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Tipo de dispositivo y sistema operativo</li>
                <li>Identificadores únicos del dispositivo</li>
                <li>Información de uso de la aplicación (funciones utilizadas, frecuencia de uso)</li>
                <li>Registros de errores y rendimiento</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">2.3 Información de Compras</h3>
              <p className="text-gray-700 mb-4">
                Las compras dentro de la aplicación se procesan a través del App Store de Apple. No tenemos acceso a su información de pago específica, solo recibimos confirmaciones de compra para activar los servicios correspondientes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Cómo Utilizamos su Información</h2>
              <p className="text-gray-700 mb-4">
                Utilizamos la información recopilada para:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Proporcionar y mantener los servicios de la Aplicación</li>
                <li>Generar facturas electrónicas y documentos tributarios</li>
                <li>Sincronizar datos con iCloud (cuando está habilitado)</li>
                <li>Procesar compras dentro de la aplicación</li>
                <li>Mejorar la funcionalidad y experiencia de usuario</li>
                <li>Proporcionar soporte técnico</li>
                <li>Cumplir con obligaciones legales aplicables</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Almacenamiento y Seguridad de Datos</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">4.1 Almacenamiento Local</h3>
              <p className="text-gray-700 mb-4">
                La mayoría de sus datos de facturación se almacenan localmente en su dispositivo iOS, lo que significa que mantenemos el control directo de su información personal y comercial.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">4.2 Sincronización con iCloud</h3>
              <p className="text-gray-700 mb-4">
                Si habilita la sincronización con iCloud, sus datos se almacenarán en los servidores de Apple de acuerdo con la política de privacidad de Apple. No tenemos acceso a estos datos almacenados en iCloud.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">4.3 Medidas de Seguridad</h3>
              <p className="text-gray-700 mb-4">
                Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Compartir Información con Terceros</h2>
              <p className="text-gray-700 mb-4">
                No vendemos, alquilamos ni compartimos su información personal con terceros, excepto en las siguientes circunstancias:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li><strong>Apple:</strong> Para procesamiento de compras dentro de la aplicación</li>
                <li><strong>Proveedores de servicios:</strong> Que nos ayudan a operar la Aplicación (con acuerdos de confidencialidad)</li>
                <li><strong>Requerimientos legales:</strong> Cuando sea requerido por ley o autoridades competentes</li>
                <li><strong>Protección de derechos:</strong> Para proteger nuestros derechos, propiedad o seguridad</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Sus Derechos de Privacidad</h2>
              <p className="text-gray-700 mb-4">
                Usted tiene los siguientes derechos respecto a su información personal:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li><strong>Acceso:</strong> Solicitar información sobre los datos que tenemos sobre usted</li>
                <li><strong>Rectificación:</strong> Corregir datos inexactos o incompletos</li>
                <li><strong>Eliminación:</strong> Solicitar la eliminación de sus datos personales</li>
                <li><strong>Portabilidad:</strong> Obtener una copia de sus datos en formato estructurado</li>
                <li><strong>Oposición:</strong> Oponerse al procesamiento de sus datos para ciertos fines</li>
              </ul>
              <p className="text-gray-700 mb-4">
                Para ejercer estos derechos, puede contactarnos através de nuestro formulario de contacto.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Retención de Datos</h2>
              <p className="text-gray-700 mb-4">
                Mantenemos su información personal solo durante el tiempo necesario para cumplir con los propósitos descritos en esta política, salvo que la ley requiera o permita un período de retención más largo.
              </p>
              <p className="text-gray-700 mb-4">
                Los datos almacenados localmente en su dispositivo se mantienen hasta que usted elimine la aplicación o borre manualmente los datos.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Transferencias Internacionales</h2>
              <p className="text-gray-700 mb-4">
                Como la Aplicación utiliza servicios de Apple (App Store, iCloud), sus datos pueden ser transferidos y almacenados en países fuera de México donde Apple opera sus centros de datos, de acuerdo con las políticas de privacidad de Apple.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Menores de Edad</h2>
              <p className="text-gray-700 mb-4">
                La Aplicación no está dirigida a menores de 18 años. No recopilamos intencionalmente información personal de menores de edad. Si descubrimos que hemos recopilado información de un menor, la eliminaremos inmediatamente.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Cambios a esta Política</h2>
              <p className="text-gray-700 mb-4">
                Podemos actualizar esta Política de Privacidad periódicamente. Le notificaremos sobre cambios significativos publicando la nueva política en la Aplicación y actualizando la fecha de "Última actualización".
              </p>
              <p className="text-gray-700 mb-4">
                Le recomendamos revisar esta política periódicamente para mantenerse informado sobre cómo protegemos su información.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Información de Contacto</h2>
              <p className="text-gray-700 mb-4">
                Si tiene preguntas sobre esta Política de Privacidad o sobre el manejo de sus datos personales, puede contactarnos:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700 mb-2"><strong>K Labs Sa de CV</strong></p>
                <p className="text-gray-700 mb-2">Email: <Link to="/contact" className="text-blue-600 hover:text-blue-700">Formulario de Contacto</Link></p>
                <p className="text-gray-700">Sitio web: <a href="https://facturas-simples.com" className="text-blue-600 hover:text-blue-700">https://facturas-simples.com</a></p>
              </div>
            </section>

            <section className="mb-8 border-t pt-6">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Información Específica para iOS</h2>
              <p className="text-gray-700 mb-4">
                Esta aplicación está diseñada para iOS y utiliza las siguientes características específicas de Apple:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li><strong>iCloud:</strong> Para sincronización opcional de datos entre dispositivos</li>
                <li><strong>App Store:</strong> Para compras dentro de la aplicación</li>
                <li><strong>iOS Keychain:</strong> Para almacenamiento seguro de credenciales</li>
                <li><strong>Notificaciones Push:</strong> Para recordatorios y actualizaciones</li>
              </ul>
              <p className="text-gray-700 mb-4">
                El uso de estos servicios está sujeto a las políticas de privacidad de Apple. Puede controlar el acceso a estos servicios a través de la configuración de iOS.
              </p>
            </section>

          </div>
        </div>

        {/* Footer Links */}
        <div className="mt-8 text-center">
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <Link to="/" className="text-blue-600 hover:text-blue-700">Inicio</Link>
            <Link to="/terms" className="text-blue-600 hover:text-blue-700">Términos y Condiciones</Link>
            <Link to="/contact" className="text-blue-600 hover:text-blue-700">Contacto</Link>
            <Link to="/faq" className="text-blue-600 hover:text-blue-700">FAQ</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;